// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reviews-page-TmbiL {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --green-d: #0f7a37;
  --amber: #f5a623;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.Reviews-wrap-r_fIJ {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Sample disclosure banner */

.Reviews-sampleBanner-kDbOd {
  max-width: 1072px;
  margin: 18px auto 0;
  padding: 12px 18px;
  border-radius: 12px;
  background: #fff7e6;
  border: 1px solid #f5d99a;
  color: #7a5200;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}

/* Stars */

.Reviews-stars-eF5XX {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  gap: 2px;
}

.Reviews-starOn-CVRjs,
.Reviews-starOff-VkC6y {
  width: 18px;
  height: 18px;
}

.Reviews-starOn-CVRjs {
  fill: var(--amber);
}

.Reviews-starOff-VkC6y {
  fill: #d7dbe0;
}

/* Stats */

.Reviews-statsSec-V1yaU {
  padding: 40px 0 8px;
}

.Reviews-statsWrap-YQrPO {
  max-width: 880px;
  margin: 0 auto;
  padding: 0 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 40px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.Reviews-statBig-uTu21 {
  text-align: center;
}

.Reviews-statNum-XdRqI {
  font-size: 56px;
  font-weight: 800;
  line-height: 1;
  color: var(--ink);
}

.Reviews-statSlash-J7Jk2 {
  font-size: 26px;
  color: var(--muted);
}

.Reviews-statBig-uTu21 .Reviews-stars-eF5XX {
  margin: 8px 0 4px;
}

.Reviews-statSub-tb4jP {
  font-size: 12px;
  color: var(--muted);
  font-weight: 600;
}

.Reviews-statCol-JIYwF {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 12px;
}

.Reviews-statItem-EW6Au {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
  gap: 10px;
}

.Reviews-statK-q93aB {
  font-weight: 800;
  color: var(--green);
  min-width: 78px;
}

.Reviews-statV-D_Jt0 {
  font-size: 14px;
  color: var(--muted);
}

/* Filter chips */

.Reviews-filterSec-RQGaU {
  padding: 28px 0 8px;
}

.Reviews-chips-OCsCD {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 10px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.Reviews-chip-vkIOb {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 38px;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: #fff;
  color: var(--ink);
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  -webkit-transition: background 0.16s, border-color 0.16s, color 0.16s;
  transition: background 0.16s, border-color 0.16s, color 0.16s;
}

.Reviews-chip-vkIOb:hover {
  border-color: #f3c9cb;
}

.Reviews-chipOn-JFmnz {
  background: var(--red);
  border-color: var(--red);
  color: #fff;
}

/* Wall */

.Reviews-wallSec-H79mg {
  padding: 28px 0 8px;
}

.Reviews-wall-IYVx2 {
  -webkit-columns: 3;
     -moz-columns: 3;
          columns: 3;
  -webkit-column-gap: 18px;
     -moz-column-gap: 18px;
          column-gap: 18px;
}

.Reviews-review-40wkK {
  position: relative;
  -webkit-column-break-inside: avoid;
     -moz-column-break-inside: avoid;
          break-inside: avoid;
  margin: 0 0 18px;
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 22px 22px 20px;
  background: #fff;
}

.Reviews-quote-y6vDI {
  margin: 12px 0 16px;
  font-size: 15px;
  line-height: 1.6;
  color: var(--ink);
}

.Reviews-meta-mK0nK {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 2px;
}

.Reviews-metaName-ze1e9 {
  font-size: 14px;
  font-weight: 800;
}

.Reviews-metaSub-MGwPb {
  font-size: 13px;
  color: var(--muted);
}

.Reviews-sampleTag-AaQr1 {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7a5200;
  background: #fff7e6;
  border: 1px solid #f5d99a;
  border-radius: 6px;
  padding: 2px 7px;
}

/* Leave a review */

.Reviews-leaveSec-OZkUl {
  padding: 40px 0 56px;
}

.Reviews-leaveCard-V3asZ {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 28px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 30px 32px;
  background: #e4f6f3;
}

.Reviews-leaveTitle-S_ICh {
  font-size: clamp(20px, 3vw, 26px);
  font-weight: 800;
  margin: 0 0 6px;
}

.Reviews-leaveText-wW0S3 {
  font-size: 15px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
  max-width: 560px;
}

.Reviews-leaveBtn-_MF1G {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 48px;
  padding: 13px 26px;
  border-radius: 14px;
  background: var(--green);
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, transform 0.16s;
  transition: background 0.16s, transform 0.16s, -webkit-transform 0.16s;
}

.Reviews-leaveBtn-_MF1G:hover {
  background: var(--green-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

@media (max-width: 960px) {
  .Reviews-wall-IYVx2 {
    -webkit-columns: 2;
       -moz-columns: 2;
            columns: 2;
  }
}

@media (max-width: 620px) {
  .Reviews-wall-IYVx2 {
    -webkit-columns: 1;
       -moz-columns: 1;
            columns: 1;
  }
  .Reviews-leaveCard-V3asZ {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    text-align: center;
  }
}

@media (prefers-color-scheme: dark) {
  .Reviews-page-TmbiL {
    background: #14171a;
    color: #f3f4f6;
  }
  .Reviews-statNum-XdRqI,
  .Reviews-metaName-ze1e9,
  .Reviews-quote-y6vDI,
  .Reviews-leaveTitle-S_ICh {
    color: #f3f4f6;
  }
  .Reviews-statSub-tb4jP,
  .Reviews-statSlash-J7Jk2,
  .Reviews-statV-D_Jt0,
  .Reviews-metaSub-MGwPb,
  .Reviews-leaveText-wW0S3 {
    color: #9aa3ad;
  }
  .Reviews-review-40wkK,
  .Reviews-chip-vkIOb {
    background: #1d2125;
    border-color: #2c3137;
    color: #f3f4f6;
  }
  .Reviews-chipOn-JFmnz {
    background: var(--red);
    border-color: var(--red);
    color: #fff;
  }
  .Reviews-starOff-VkC6y {
    fill: #3a4047;
  }
  .Reviews-leaveCard-V3asZ {
    background: rgba(22, 163, 74, 0.12);
    border-color: #2c3137;
  }
  .Reviews-sampleBanner-kDbOd {
    background: rgba(245, 166, 35, 0.12);
    border-color: rgba(245, 166, 35, 0.4);
    color: #f0c674;
  }
  .Reviews-sampleTag-AaQr1 {
    background: rgba(245, 166, 35, 0.14);
    border-color: rgba(245, 166, 35, 0.4);
    color: #f0c674;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/reviews/Reviews.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,6BAA6B;;AAC7B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,UAAU;;AACV;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,QAAQ;AACV;;AACA;;EAEE,WAAW;EACX,YAAY;AACd;;AACA;EACE,kBAAkB;AACpB;;AACA;EACE,aAAa;AACf;;AAEA,UAAU;;AACV;EACE,mBAAmB;AACrB;;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA;EACE,kBAAkB;AACpB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AACA;EACE,iBAAiB;AACnB;;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;AACX;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;EACrB,SAAS;AACX;;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,iBAAiB;;AACjB;EACE,mBAAmB;AACrB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,qEAA6D;EAA7D,6DAA6D;AAC/D;;AACA;EACE,qBAAqB;AACvB;;AACA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;AACb;;AAEA,SAAS;;AACT;EACE,mBAAmB;AACrB;;AACA;EACE,kBAAU;KAAV,eAAU;UAAV,UAAU;EACV,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;AAClB;;AACA;EACE,kBAAkB;EAClB,kCAAmB;KAAnB,+BAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;AACV;;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;;AACnB;EACE,oBAAoB;AACtB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6DAA6C;EAA7C,qDAA6C;EAA7C,6CAA6C;EAA7C,sEAA6C;AAC/C;;AACA;EACE,0BAA0B;EAC1B,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE;IACE,kBAAU;OAAV,eAAU;YAAV,UAAU;EACZ;AACF;;AACA;EACE;IACE,kBAAU;OAAV,eAAU;YAAV,UAAU;EACZ;EACA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;;;;IAIE,cAAc;EAChB;EACA;;;;;IAKE,cAAc;EAChB;EACA;;IAEE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;EACA;IACE,oCAAoC;IACpC,qCAAqC;IACrC,cAAc;EAChB;EACA;IACE,oCAAoC;IACpC,qCAAqC;IACrC,cAAc;EAChB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --green-d: #0f7a37;\n  --amber: #f5a623;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* Sample disclosure banner */\n.sampleBanner {\n  max-width: 1072px;\n  margin: 18px auto 0;\n  padding: 12px 18px;\n  border-radius: 12px;\n  background: #fff7e6;\n  border: 1px solid #f5d99a;\n  color: #7a5200;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Stars */\n.stars {\n  display: inline-flex;\n  gap: 2px;\n}\n.starOn,\n.starOff {\n  width: 18px;\n  height: 18px;\n}\n.starOn {\n  fill: var(--amber);\n}\n.starOff {\n  fill: #d7dbe0;\n}\n\n/* Stats */\n.statsSec {\n  padding: 40px 0 8px;\n}\n.statsWrap {\n  max-width: 880px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  gap: 40px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.statBig {\n  text-align: center;\n}\n.statNum {\n  font-size: 56px;\n  font-weight: 800;\n  line-height: 1;\n  color: var(--ink);\n}\n.statSlash {\n  font-size: 26px;\n  color: var(--muted);\n}\n.statBig .stars {\n  margin: 8px 0 4px;\n}\n.statSub {\n  font-size: 12px;\n  color: var(--muted);\n  font-weight: 600;\n}\n.statCol {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.statItem {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n.statK {\n  font-weight: 800;\n  color: var(--green);\n  min-width: 78px;\n}\n.statV {\n  font-size: 14px;\n  color: var(--muted);\n}\n\n/* Filter chips */\n.filterSec {\n  padding: 28px 0 8px;\n}\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n}\n.chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 8px 16px;\n  border-radius: 999px;\n  border: 1px solid var(--line);\n  background: #fff;\n  color: var(--ink);\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.16s, border-color 0.16s, color 0.16s;\n}\n.chip:hover {\n  border-color: #f3c9cb;\n}\n.chipOn {\n  background: var(--red);\n  border-color: var(--red);\n  color: #fff;\n}\n\n/* Wall */\n.wallSec {\n  padding: 28px 0 8px;\n}\n.wall {\n  columns: 3;\n  column-gap: 18px;\n}\n.review {\n  position: relative;\n  break-inside: avoid;\n  margin: 0 0 18px;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 22px 22px 20px;\n  background: #fff;\n}\n.quote {\n  margin: 12px 0 16px;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--ink);\n}\n.meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.metaName {\n  font-size: 14px;\n  font-weight: 800;\n}\n.metaSub {\n  font-size: 13px;\n  color: var(--muted);\n}\n.sampleTag {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #7a5200;\n  background: #fff7e6;\n  border: 1px solid #f5d99a;\n  border-radius: 6px;\n  padding: 2px 7px;\n}\n\n/* Leave a review */\n.leaveSec {\n  padding: 40px 0 56px;\n}\n.leaveCard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 28px;\n  flex-wrap: wrap;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 30px 32px;\n  background: #e4f6f3;\n}\n.leaveTitle {\n  font-size: clamp(20px, 3vw, 26px);\n  font-weight: 800;\n  margin: 0 0 6px;\n}\n.leaveText {\n  font-size: 15px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n  max-width: 560px;\n}\n.leaveBtn {\n  display: inline-flex;\n  align-items: center;\n  min-height: 48px;\n  padding: 13px 26px;\n  border-radius: 14px;\n  background: var(--green);\n  color: #fff;\n  font-weight: 700;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: background 0.16s, transform 0.16s;\n}\n.leaveBtn:hover {\n  background: var(--green-d);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 960px) {\n  .wall {\n    columns: 2;\n  }\n}\n@media (max-width: 620px) {\n  .wall {\n    columns: 1;\n  }\n  .leaveCard {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .statNum,\n  .metaName,\n  .quote,\n  .leaveTitle {\n    color: #f3f4f6;\n  }\n  .statSub,\n  .statSlash,\n  .statV,\n  .metaSub,\n  .leaveText {\n    color: #9aa3ad;\n  }\n  .review,\n  .chip {\n    background: #1d2125;\n    border-color: #2c3137;\n    color: #f3f4f6;\n  }\n  .chipOn {\n    background: var(--red);\n    border-color: var(--red);\n    color: #fff;\n  }\n  .starOff {\n    fill: #3a4047;\n  }\n  .leaveCard {\n    background: rgba(22, 163, 74, 0.12);\n    border-color: #2c3137;\n  }\n  .sampleBanner {\n    background: rgba(245, 166, 35, 0.12);\n    border-color: rgba(245, 166, 35, 0.4);\n    color: #f0c674;\n  }\n  .sampleTag {\n    background: rgba(245, 166, 35, 0.14);\n    border-color: rgba(245, 166, 35, 0.4);\n    color: #f0c674;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Reviews-page-TmbiL`,
	"wrap": `Reviews-wrap-r_fIJ`,
	"sampleBanner": `Reviews-sampleBanner-kDbOd`,
	"stars": `Reviews-stars-eF5XX`,
	"starOn": `Reviews-starOn-CVRjs`,
	"starOff": `Reviews-starOff-VkC6y`,
	"statsSec": `Reviews-statsSec-V1yaU`,
	"statsWrap": `Reviews-statsWrap-YQrPO`,
	"statBig": `Reviews-statBig-uTu21`,
	"statNum": `Reviews-statNum-XdRqI`,
	"statSlash": `Reviews-statSlash-J7Jk2`,
	"statSub": `Reviews-statSub-tb4jP`,
	"statCol": `Reviews-statCol-JIYwF`,
	"statItem": `Reviews-statItem-EW6Au`,
	"statK": `Reviews-statK-q93aB`,
	"statV": `Reviews-statV-D_Jt0`,
	"filterSec": `Reviews-filterSec-RQGaU`,
	"chips": `Reviews-chips-OCsCD`,
	"chip": `Reviews-chip-vkIOb`,
	"chipOn": `Reviews-chipOn-JFmnz`,
	"wallSec": `Reviews-wallSec-H79mg`,
	"wall": `Reviews-wall-IYVx2`,
	"review": `Reviews-review-40wkK`,
	"quote": `Reviews-quote-y6vDI`,
	"meta": `Reviews-meta-mK0nK`,
	"metaName": `Reviews-metaName-ze1e9`,
	"metaSub": `Reviews-metaSub-MGwPb`,
	"sampleTag": `Reviews-sampleTag-AaQr1`,
	"leaveSec": `Reviews-leaveSec-OZkUl`,
	"leaveCard": `Reviews-leaveCard-V3asZ`,
	"leaveTitle": `Reviews-leaveTitle-S_ICh`,
	"leaveText": `Reviews-leaveText-wW0S3`,
	"leaveBtn": `Reviews-leaveBtn-_MF1G`
};
module.exports = ___CSS_LOADER_EXPORT___;
